/* الكيميائي — theme scripts (no dependencies) */
(function () {
  'use strict';

  var routes = window.theme && window.theme.routes ? window.theme.routes : { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var strings = (window.theme && window.theme.strings) || {};
  var root = routes.root.replace(/\/$/, '') + '/';

  document.documentElement.classList.remove('no-js');

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var toastTimer;
  function toast(message) {
    var el = $('#Toast');
    if (!el) return;
    $('.toast__text', el).textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function lockScroll(lock) { document.body.classList.toggle('is-locked', lock); }

  /* ---------- Sticky header shadow ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = $('#MobileMenu');
  function toggleMenu(open) {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    lockScroll(open);
    if (open) { var f = $('a, button', mobileMenu); if (f) f.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); toggleMenu(true); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); toggleMenu(false); }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = function () { return $('#CartDrawer'); };
  var lastFocus;
  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var close = $('[data-drawer-close]', d);
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener && window.theme.cartType === 'drawer' && drawer()) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); }
  });

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('.drawer__inner', doc);
        var current = $('#CartDrawer .drawer__inner');
        if (fresh && current) current.replaceWith(fresh);
        var count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) updateCount(count);
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* Drawer: remove + quantity */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove], [data-qty-change]');
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    var item = btn.closest('[data-line]');
    var line = parseInt(item.getAttribute('data-line'), 10);
    var qty = 0;
    if (btn.hasAttribute('data-qty-change')) {
      var input = $('input', item);
      qty = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
    }
    item.style.opacity = '.5';
    changeLine(line, qty).then(refreshDrawer);
  });

  /* Cart page: +/- buttons update the input, then submit the form */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn || btn.closest('#CartDrawer')) return;
    var wrap = btn.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    e.preventDefault();
    input.value = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
    var form = input.form;
    if (form && form.hasAttribute('data-autosubmit')) form.submit();
  });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (window.theme.cartType !== 'drawer') return; // let page cart do a normal post
    e.preventDefault();

    var button = $('[type="submit"]', form);
    var errorEl = form.parentElement && $('.product__error', form.parentElement);
    if (errorEl) errorEl.textContent = '';
    if (button) button.classList.add('is-loading');

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.json.description || res.json.message || strings.error;
          if (errorEl) errorEl.textContent = msg; else toast(msg);
          return;
        }
        return refreshDrawer().then(function () {
          if (drawer()) openDrawer(); else toast(strings.added);
        });
      })
      .catch(function () { toast(strings.error); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  });

  /* ---------- Product page: media gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = $('[data-main-media] img', gallery);
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    main.removeAttribute('srcset');
    main.alt = thumb.getAttribute('data-alt') || '';
    $$('[data-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
  });

  /* ---------- Product page: variant picker ---------- */
  $$('[data-product-json]').forEach(function (script) {
    var section = script.closest('[data-product-section]');
    var product;
    try { product = JSON.parse(script.textContent); } catch (err) { return; }
    var idInput = $('[name="id"]', section);
    var pickers = $$('[data-option-index]', section);

    function selectedOptions() {
      return pickers.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function money(cents) {
      var fmt = window.theme.moneyFormat || '{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
        if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
        return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var buttons = $$('[data-add-button]', section);
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; $('span', b).textContent = strings.unavailable; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      buttons.forEach(function (b) {
        b.disabled = !variant.available;
        $('span', b).textContent = variant.available ? strings.addToCart : strings.soldOut;
      });
      $$('[data-price]', section).forEach(function (wrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wrap.classList.toggle('price--sale', !!onSale);
        var cur = $('.price__current', wrap); if (cur) cur.textContent = money(variant.price);
        var cmp = $('.price__compare', wrap);
        if (cmp) { cmp.textContent = onSale ? money(variant.compare_at_price) : ''; cmp.hidden = !onSale; }
        var save = $('.price__save', wrap);
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = (strings.save || '').replace('[amount]', Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price));
        }
      });
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    pickers.forEach(function (fs) { fs.addEventListener('change', update); });
  });

  /* ---------- Sticky mobile buy bar ---------- */
  var stickyBuy = $('[data-sticky-buy]');
  var buyAnchor = $('[data-buy-anchor]');
  if (stickyBuy && buyAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(buyAnchor);
    var stickyBtn = $('button', stickyBuy);
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var btn = $('[data-add-button]', buyAnchor);
      if (btn) btn.click();
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = $('[data-recommendations-url]', doc);
        if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
      });
  });

  /* ---------- Collection filters auto-submit ---------- */
  $$('[data-autosubmit-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { form.submit(); }, 250); });
  });
  /* Controls associated via the form="" attribute (e.g. sort select outside the filter form) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-autosubmit-input]');
    if (input && input.form) input.form.submit();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Theme editor: re-run reveal when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
